import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type transformationPermissionType = 'transformation_view';

export const transformationPermissionMatrix: IPermissionMatrix<transformationPermissionType> = {
  transformation_view: [UserRole.user, UserRole.coach]
};
